// Interne Bentomax-Projekte — Spiegel der Backend-Konstanten. Die Quelle der
// Wahrheit ist das Backend (Project::BENTOMAX_INTERN_ID bzw.
// PickupOrderCreationService::PICKUP_PROJECT_ID); Änderungen dort müssen hier
// nachgezogen werden. Bewusst als zentrale Frontend-Konstante statt verstreuter
// Magic Numbers (siehe hawk#556, Aufgabe D) — ein Config-Endpoint wäre die
// nächste Ausbaustufe, lohnt für zwei stabile IDs aber (noch) nicht.

// Interner Materialversand (Projekt 209) — z. B. Filialauswahl der
// Versandfiliale auf der User-Edit-Seite.
export const INTERNAL_SHIPPING_PROJECT_ID = 209;

// Interne Abholaufträge "[INTERN] - Bentomax" (Projekt 133).
export const INTERNAL_PICKUP_PROJECT_ID = 133;

// Alle internen Projekte (z. B. für Routen-Logik: keine Standortwechsel).
export const INTERNAL_PROJECT_IDS: number[] = [INTERNAL_PICKUP_PROJECT_ID, INTERNAL_SHIPPING_PROJECT_ID];
